export enum ActionTypes {
  REMOVE_BLOCK_ACTION_META = 'REMOVE_BLOCK_ACTION_META',
}

export interface RemoveBlockActionMeta {
  type: ActionTypes.REMOVE_BLOCK_ACTION_META;
  blockId: string;
}

export type BlockActionMetaActions = RemoveBlockActionMeta;
